<template>
    <v-layout row>      
        <v-flex xs12 sm12>         
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to My Teams" @click="$router.push('/myteam')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-btn dark icon title="View this month" @click="getEvents">
                        <v-icon>far fa-calendar-alt</v-icon>
                    </v-btn>
                    <help-link appId="attendance" pageId="team-calendar" color="white"></help-link>
                    <v-spacer></v-spacer>
                    <v-btn dark icon small title="Previous Month" @click="getPrevOrNext(-1)" :disabled="loading" style="margin-right:-3px;" >
                        <v-icon>chevron_left</v-icon>
                    </v-btn>
                    <v-toolbar-title class="subheading transparent white--text">{{ startMonth | moment("MMM YYYY") }}</v-toolbar-title>
                    <v-btn dark icon small title="Next Month" @click="getPrevOrNext(1)" :disabled="loading">
                        <v-icon>chevron_right</v-icon>
                    </v-btn>
                </v-toolbar>
                <!-- <v-progress-linear v-if="loading" color="primary" height="1" style="margin:1px -3px 0px -3px;" indeterminate></v-progress-linear> -->
            </v-card>
            <v-alert v-if="error" :value="true" color="warning" icon="warning" outline style="margin-top:10px;">
                {{errorMessage}}
            </v-alert>  
            <v-layout row wrap style="padding-top:5px;"> 
                <v-flex xs12>
                    <v-card class="elavation-1 transparent"> 
                        <v-sheet height="500">
                            <v-calendar
                                ref="calendar"
                                v-model="startMonth"
                                :now="today"
                                :value="today"
                                color="primary"
                                >
                                <template v-slot:day="{ date }">
                                    <template v-for="event in eventsMap[date]">

                                        <!-- holiday -->
                                        <v-menu :key="event.transDate" v-model="event.menuHoliday" full-width offset-x>
                                            <template v-slot:activator="{ on }">
                                                <v-chip v-if="event.holiday" v-on="on" color="#BBDEFB">
                                                    {{event.holiday}}
                                                </v-chip>
                                            </template> 
                                            <v-card max-width="400px" flat>
                                                <v-toolbar flat height="45px">
                                                    <b v-if="event.holiday">
                                                        {{event.holiday}}
                                                    </b>   
                                                    <v-spacer></v-spacer>
                                                </v-toolbar>
                                                <v-card-text>
                                                    <div v-if="event.holiday">
                                                        {{event.holidayType}}
                                                    </div>                                          
                                                </v-card-text>
                                            </v-card> 
                                        </v-menu>

                                        <!-- birthday -->
                                        <v-menu :key="event.transDate" v-model="event.menuBirthday" full-width offset-x>
                                            <template v-slot:activator="{ on }">
                                                <v-chip v-if="event.withBirthDay" v-on="on" color="#F8BBD0">
                                                    Birthdays
                                                </v-chip>
                                            </template> 
                                            <v-card max-width="400px" flat>
                                                <v-toolbar flat height="45px">
                                                    <b v-if="event.withBirthDay">
                                                        Happy Birthday
                                                    </b>
                                                    <v-spacer></v-spacer>
                                                </v-toolbar>
                                                <v-card-text>
                                                    <div v-if="event.withBirthDay">
                                                        <div v-for="(item, index) in event.birthdayItems" :key="index">
                                                            <v-chip small >
                                                                <v-avatar size="20">
                                                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(item.userId)"></v-img>
                                                                </v-avatar>
                                                                {{item.firstName}} {{item.lastName}} 
                                                            </v-chip><br>
                                                        </div>
                                                    </div>                                           
                                                </v-card-text>
                                            </v-card> 
                                        </v-menu>

                                        <!-- timeoffs -->
                                        <v-menu :key="event.transDate" v-model="event.menuTimeoffs" full-width offset-x>
                                            <template v-slot:activator="{ on }">
                                                <v-chip v-if="event.withPTO" v-on="on" color="#B2DFDB">
                                                    Time Offs
                                                </v-chip>
                                            </template> 
                                            <v-card max-width="400px" flat>
                                                <v-toolbar flat height="45px">
                                                    <b v-if="event.withPTO">
                                                        Time Offs
                                                    </b>
                                                    <v-spacer></v-spacer>
                                                </v-toolbar>
                                                <v-card-text>
                                                    <div v-if="event.withPTO">
                                                        <div v-for="(item, index) in event.ptoItems" :key="index">
                                                            <v-chip small >
                                                                <v-avatar size="20">
                                                                    <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(item.userId)"></v-img>
                                                                </v-avatar>
                                                                {{item.firstName}} {{item.lastName}} 
                                                            </v-chip><br>
                                                        </div>
                                                    </div>                                           
                                                </v-card-text>
                                            </v-card> 
                                        </v-menu>
                                        
                                    </template>
                                </template>
                            </v-calendar>
                        </v-sheet>
                    </v-card>
                </v-flex>
            </v-layout>
            <br>
        </v-flex>
    </v-layout>
</template>

<script>

import teamApi from '@/api/team'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    name: 'TeamTeamCalendar',
    metaInfo: {
        title: 'Team Calendar',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: "View In Calendar View my team's time off, holidays, birthdays, etc." },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data() {
        return {
            awsS3Helper,
            toggle_view: 1,
            loading: false,
            error: false,
            errorMessage: '',
            serverDate: '',
            today: null,
            events_list: [],
            startMonth: null,
            selectedDate: null,
        }
    },
    methods: {
        viewDaily(transDate) {
            this.$router.push('/myattendance/' + this.$moment(transDate).format('YYYY-MM-DD')) 
        },
        open(event) {
            alert(event.title)
        },
        viewToday() {
            this.$router.push('/myattendance') 
        },
        getServerDate() {
            this.serverDate = Date.now()
            this.today = this.$moment(Date.now()).format("YYYY-MM-DD")
            this.selectedDate = Date.now()
            this.startMonth = this.$moment(this.serverDate).format("YYYY-MM-DD")
        },  
        async getEvents(){
            try {
                this.loading = true
                const response = await teamApi.getTeamEventsByMonth(this.$moment(this.serverDate).format("YYYY-MM-DD")) 
                if (response && response.status == 200) {
                    this.events_list = response.data.items
                    this.selectedDate = this.serverDate
                    this.today = this.$moment(this.serverDate).format("YYYY-MM-DD")
                    this.startMonth = this.$moment(this.serverDate).format("YYYY-MM-DD")
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async getPrevOrNext(day){
            try {
                this.loading = true
                this.selectedDate = this.$moment(this.selectedDate).add(day, 'month')
                this.today = this.$moment(this.selectedDate).format("YYYY-MM-DD")
                this.startMonth = this.$moment(this.selectedDate).format("YYYY-MM-DD")

                const response = await teamApi.getTeamEventsByMonth(this.$moment(this.selectedDate).format("YYYY-MM-DD"))
                if (response && response.status == 200) {
                    this.events_list = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    async created() {
        this.loading = true
        this.serverDate = Date.now()

        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.$store.state.selectedTeamName} Calendar`
        })

        this.getServerDate()
        await this.getEvents()

        this.loading = false
    },
    computed: {
        // convert the list of events into a map of lists keyed by date
        eventsMap () {
            const map = {}
            this.events_list.forEach(e => (map[this.$moment(e.transDate).format("YYYY-MM-DD")] = map[this.$moment(e.transDate).format("YYYY-MM-DD")] || []).push(e))
            return map
        },
    },
}
</script>
<style lang="stylus" scoped>
.my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;    
    color: #ffffff;
    width: 100%;
    font-size: 12px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
}
</style>